export class CostReviewBidDocumentationAvailable {
  isBidDocumentationApplicableLessThanThreshold!: boolean;
  isBidDocumentationApplicable!: boolean;
  jobSpecifications!: number;
  mechanicalDrawings!: number;
  exceptionsClarifications!: number;
  scopeOfWorkLetter!: number;
  projectContractAddenda!: string;
  producPromotionReceived!: string; // ToDo - Check spell
  subsidyReceived!: number;
  notes!: string;
  fireSystemElectricalDrawings!: number;
  smokeControlSequence!: number;
  securitySystemElectricalDrawings!: number;
  productDiscount!: number;
  listAllAddenda!: string;
}
